import { inputTypes } from 'components/common/FormElements/Input'
import {
  VEHICLE_SELECTOR_FIELD_NAME,
  STORE_SELECTOR_FIELD_NAME,
  SERVICES_SELECTOR_FIELD_NAME,
  DATE_TIME_SELECTOR_FIELD_NAME,
  SERVICES_COMMENT_FIELD_NAME,
  ACTIVE_PROMOTIONS_FIELD_NAME
} from 'constant'

export default {
  vehicleSelector: {
    name: VEHICLE_SELECTOR_FIELD_NAME
  },
  storeSelector: {
    name: STORE_SELECTOR_FIELD_NAME
  },
  servicesSelector: {
    name: SERVICES_SELECTOR_FIELD_NAME
  },
  dateTimePicker: {
    name: DATE_TIME_SELECTOR_FIELD_NAME
  },
  serviceComment: {
    name: SERVICES_COMMENT_FIELD_NAME,
    inputType: inputTypes.TEXTAREA_INPUT,
    label: 'Tell us more (optional)'
  },
  activePromotionsList: {
    name: ACTIVE_PROMOTIONS_FIELD_NAME
  }
}
